<template>
  <b-col sm="12" :lg="lgSize" :offset-lg="lgOffset">
    <div class="animated fadeIn">
      <b-modal
        title="Choose period"
        class="modal-primary"
        v-model="modalDate"
        @ok="fetchData(), modalDate = false"
      >
        <b-form>
          <b-form-group label="From" label-for="date" :label-cols="3">
            <datepicker use-utc
              format="MM/dd/yyyy"
              :bootstrap-styling="true"
              v-model="dateFrom"
              name="dateFrom"
            ></datepicker>
          </b-form-group>
          <b-form-group label="To" label-for="dateTo" :label-cols="3">
            <datepicker use-utc
              format="MM/dd/yyyy"
              :bootstrap-styling="true"
              v-model="dateTo"
              name="dateTo"
            ></datepicker>
          </b-form-group>
        </b-form>
      </b-modal>

      <b-card class="backClass" header="Received">
        <div slot="header">
          <h5 style="display: inline;" class="card-title mb-0">
            Under Warranty {{ alpha }}
            <small style="font-weight:600; color:#20a8d8">
              {{ from ? $formatUSDate(from) : $formatUSDate(dateFrom) }}
              <b>|</b>
              {{ to ? $formatUSDate(to) : $formatUSDate(dateTo) }}
            </small>
          </h5>
          <div class="card-header-actions">
            <b-button
              @click="toggleFullScreen"
              style="height: 26px; width: 26px"
              class="float-right"
              variant="transparent p-0"
              right
            >
              <i style="color: #20a8d8;" class="icon-frame"></i>
            </b-button>
            <b-button
              @click="modalDateEvent"
              class
              style="height: 26px; width: 26px"
              variant="transparent p-0"
            >
              <i class="icon-calendar" style="color: #20a8d8;"></i>
            </b-button>
            <b-button
              class="btn"
              style="height: 26px; width: 26px"
              variant="transparent p-0"
              attr="pdf"
              @click="downloadPDF()"
            >
              <i class="fa fa-file-pdf-o" style="color: rgb(32, 168, 216);" aria-hidden="true"></i>
            </b-button>
          </div>
        </div>

        <div class="chart-wrapper">
          <div style="height: 400px; padding-top: 150px" v-if="loadingData" class="loading">
            <b-row>
              <b-col lg="12">
                <div class="sk-double-bounce">
                  <div class="sk-child sk-double-bounce1"></div>
                  <div class="sk-child sk-double-bounce2"></div>
                </div>
              </b-col>
            </b-row>
          </div>
          <highcharts
            ref="backRef"
            v-else
            :options="chartOptions"
            class="chart"
            :constructor-type="'chart'"
          ></highcharts>
        </div>
        <!-- <div style="width: 100%; display: flex; justify-content: flex-end;">
          <b-form-checkbox
            id="checkbox-2"
            class="mx-1"
            v-model="toggleData"
            name="checkbox-2"
            value="true"
            unchecked-value="false"
          >Show / Hide All</b-form-checkbox>
        </div> -->
        <div slot="footer">
          <b-button
            :disabled="!showAll"
            class="btn-outline"
            variant="outline-primary"
            left
            @click="showAll = false, fetchData()"
          >Top 10</b-button>

          <b-button
            :disabled="showAll"
            class="btn-outline float-right"
            variant="outline-primary"
            right
            @click="showAll = true, fetchData()"
          >All Data</b-button>
        </div>
      </b-card>
    </div>
  </b-col>
</template>

<script>
  import { Chart } from "highcharts-vue";
  import router from "../router";
  import Datepicker from "vuejs-datepicker";
  import { Switch as cSwitch } from "@coreui/vue";

  export default {
    name: "ActiveBacklog-Stacked",
    components: {
      router,
      highcharts: Chart,
      cSwitch,
      Datepicker
    },
    props: ["lgSize", "lgOffset", "locParam", "idCity", "nameCity", "alpha"],
    data: function() {
      return {
        fullscreen: false,
        loadingData: false,
        showAll: false,
        modalDate: false,
        toggleData: false,
        dateFrom: "",
        dateTo: "",
        locationName: "",
        productGroup: "",
        locationsIds: "",
        chartOptions: {
          tooltip: {
            formatter: function() {
              return;
            }
          },
          chart: {
            type: "column",
            backgroundColor: "transparent"
          },
          exporting: {
            enabled: true
          },
          title: {
            text: "",
            style: {
              color: "white",
              display: ""
            }
          },
          legend: {
            enabled: false,
            itemStyle: {
              color: "white"
            }
          },
                  xAxis: {
          type: "category",
          labels: {
            style: {
              color: "white"
            }
          }
        },
        yAxis: {
          title: {
            text: "Percentage Of Total"
          }
        },
        legend: {
          enabled: false
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat:
            "<span >{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>"
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: false,
              format: "{point.name}: {point.y:.1f}%",
              color: "white",
              style: {
                textOutline: false
              }
            },
            point: {
              events: {
                click: ({ point }) => {
                  if (typeof this.dateFrom === "object") {
                    this.dateFrom = this.dateFrom.toISOString().split("T")[0];
                  }
                  if (typeof this.dateTo === "object") {
                    this.dateTo = this.dateTo.toISOString().split("T")[0];
                  }
                  if (point.name) {
                    let name = point.name.split("(");
                    router.push(
                        "Tables/?productModel=" + name[0] + "%287%29" +"&date_from="+this.dateFrom+"&date_to=" +this.dateTo+"&type=war"
                    );
                  }
                }
              }
            }
          }
        },
        drilldown: {
          activeAxisLabelStyle: {
            textDecoration: "none",
            color: "white"
          },
          activeDataLabelStyle: {
            color: "white"
          }
        },
        series: [
          {
            name: "Model",
            colorByPoint: true,
            data: null
          }
        ]
        }
      };
    },
    watch: {
      valueQuantity(value) {
        this.fetchData();
        if (this.fullScreen) {
          this.$refs.backRef.chart.options.chart.height = "50%";
        } else {
          this.$refs.backRef.chart.options.chart.height = 400;
        }
      },
      toggleData(param) {
        var chartSeries = this.$refs.backRef.chart.series;
        console.log(param);
        chartSeries.forEach(obj => {
          if (param === "false") {
            obj.show();
          } else {
            obj.hide();
          }
        });
      }
    },

    methods: {
      toggleFullScreen() {
        this.$fullscreen.toggle(this.$el.querySelector(".backClass"), {
          wrap: false,
          callback: this.fullscreenChange
        });
      },
      fullscreenChange(fullscreen) {
        this.fullscreen = fullscreen;
        if (this.fullscreen) {
          this.$refs.backRef.chart.options.chart.height = "50%";
        } else {
          this.$refs.backRef.chart.options.chart.height = 400;
        }
        this.$refs.backRef.chart.reflow();
      },
      fetchData() {
        this.loadingData = true;

        let params = {};
        params = {
          date_from: this.dateFrom,
          date_to: this.dateTo,
          chartType: "war",
          alpha: this.alpha
        };
        this.$http
          .get("api/alpha/charts/chart_data_alpha.php", {
            params
          })
          .then(
            res => {
            if (!this.showAll) {
              let tmp = res.data.upData;
              tmp.sort((a, b) =>
                parseFloat(a.locationTotal) > parseFloat(b.locationTotal)
                  ? -1
                  : 1
              );


              let newArr = tmp.slice(0, 10);
              this.chartOptions.series[0].data = newArr;

            } else {

              let tmp = res.data.upData;
              tmp.sort((a, b) =>
                parseFloat(a.locationTotal) > parseFloat(b.locationTotal)
                  ? -1
                  : 1
              );

                this.chartOptions.series[0].data = tmp;
            }

              this.chartOptions.title.text = "Total units: " + res.data.totals;

              this.loadingData = false;
            },
            err => {
              this.loadingData = false;
              console.log(err);
            }
          );
      },
      changeHeight() {
        if (this.fullscreen) {
          this.$refs.backRef.chart.options.chart.height = "50%";
        } else {
          this.$refs.backRef.chart.options.chart.height = 400;
        }
        this.$refs.backRef.chart.reflow();
      },
      modalDateEvent() {
        if (this.fullScreen) {
          this.toggleFullScreen();
          this.modalDate = true;
        } else {
          this.modalDate = true;
        }
      },
      downloadPDF() {
        if (this.locParam == 1) {
          this.$refs.backRef.chart.options.title.text =
            "Under Warranty | " + this.dateTo;
        } else {
          this.$refs.backRef.chart.options.title.text =
            "Under Warranty | " + this.dateTo + " " + this.nameCity;
        }

        this.$refs.backRef.chart.options.title.style.display = "block";
        this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
          "black";
        this.$refs.backRef.chart.options.legend.itemStyle.color = "black";

        this.$refs.backRef.chart.options.xAxis.forEach(obj => {
          obj.labels.style.color = "black";
        });
        this.$refs.backRef.chart.options.yAxis.forEach(obj => {
          obj.labels.style.color = "black";
        });

        this.$refs.backRef.chart.exportChart({
          type: "application/pdf",
          filename: "Warr-" + this.dateTo
        });

        this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
          "white";
        this.$refs.backRef.chart.options.legend.itemStyle.color = "white";
      }
    },
    computed: {
      from() {
        if (typeof this.dateFrom === "object") {
          this.dateFrom = this.dateFrom.toISOString().split("T")[0];
          return this.dateFrom;
        }
      },
      to() {
        if (typeof this.dateTo === "object") {
          this.dateTo = this.dateTo.toISOString().split("T")[0];
          return this.dateTo;
        }
      }
    },
    mounted() {
      if (!localStorage.getItem("alpha_user")) {
        router.push("/pages/login/");
      }

      if (this.locParam == 1) {
        this.locationsIds = localStorage.getItem("locations");
      } else {
        this.locationsIds = this.idCity;
      }

      let fromDate = new Date();
      fromDate.setDate(fromDate.getDate() - 30);

      this.dateFrom = fromDate.toJSON().slice(0, 10);
      this.dateTo = new Date().toJSON().slice(0, 10);
      this.fetchData();
    }
  };
</script>

<style>
  /* IE fix */
  #card-chart-01,
  #card-chart-02 {
    width: 100% !important;
  }

  .vdp-datepicker__calendar {
    position: absolute !important;
    z-index: 100;
    background: #3a4149 !important;
    width: 300px;
    border: 1px solid #ccc;
  }
  .form-control:disabled,
  .form-control[readonly] {
    background-color: #515b65 !important;
    opacity: 1 !important;
  }
</style>
